// This component displays the entire menu preview.

import { ICafeListItemViewModel } from "@dining/api-client";
import React from "react";
import { useSelector } from "react-redux";
import { notificationStateSelector } from "../../selectors/diningSelector";
import MenuPreviewHeader from "./MenuPreviewHeader";
import MenuWeekdaySelector from "./MenuWeekdaySelector";
import { PreviewMenu } from "./types/menuPreviewTypes";

export interface MenuPreviewViewProps {
  selectedCafe: ICafeListItemViewModel;
  weeklyMenu: Array<PreviewMenu[]>;
}

const MenuPreviewView = ({ selectedCafe, weeklyMenu }: MenuPreviewViewProps) => {
  const menuPublishedState = useSelector(notificationStateSelector);
  return (
    <div className="menuContainer">
      <MenuPreviewHeader
        cafeName={selectedCafe.name}
        serviceHours={selectedCafe.serviceHours}
        notificationState={menuPublishedState}
      />
      <MenuWeekdaySelector weeklyMenu={weeklyMenu} />
    </div>
  );
};

export default MenuPreviewView;
